<template>
  <div class="px-10">
    <v-expansion-panels
      v-model="panel"
      multiple
      class="elevation-2"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
          {{ section }} 
          <employee-profile-general-info-working-experience-dialog-create
            v-if="panel.length > 0 && $hasPermissionTo(['create working experiences']) && !isMyProfile && !isResigned"
            :employee-uid="employeeUid"
            @created="loadWorkingExperiences"
          />
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="workingExperiences"
            hide-default-footer
            dense
            class="border mt-4"
          >
            <template v-slot:item.company_name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.company_name }}
                </span>
              </div>
            </template>

            <template v-slot:item.duration="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ $moment(item.end_date).diff($moment(item.start_date), 'month') + ' month(s) ' }}
                </span>
              </div>
            </template>

            <template v-slot:item.start_date="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                />  
                <span v-else>
                  {{ $moment(item.start_date).format('MMM YYYY') }}
                </span>
              </div>
            </template>

            <template v-slot:item.end_date="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                />  
                <span v-else>
                  {{ $moment(item.end_date).format('MMM YYYY') }}
                </span>
              </div>
            </template>

            <template v-slot:item.reason="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.reason }}
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <employee-profile-general-info-working-experience-dialog-edit
                v-if="$hasPermissionTo(['update working experiences']) && !loading && !isMyProfile && !isResigned"
                :working-experience="item"
                @updated="loadWorkingExperiences"
              />
          
              <employee-profile-general-info-working-experience-dialog-delete
                v-if="$hasPermissionTo(['delete working experiences']) && !loading && !isMyProfile && !isResigned" 
                :working-experience="item"
                @deleted="loadWorkingExperiences"
              />
            </template>  
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileGeneralInfoWorkingExperienceDialogCreate: () => import('@/components/hris/employee/profile/general-info/working-experience/DialogCreate'),
      EmployeeProfileGeneralInfoWorkingExperienceDialogEdit: () => import('@/components/hris/employee/profile/general-info/working-experience/DialogEdit'),
      EmployeeProfileGeneralInfoWorkingExperienceDialogDelete: () => import('@/components/hris/employee/profile/general-info/working-experience/DialogDelete'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        section: 'Working Experiences',
        workingExperiences: [],
        headers: [
          { 
            text: 'Previous Company', 
            align: 'left',
            sortable: false,
            value: 'company_name',
          },
          { 
            text: 'Occupation', 
            align: 'left',
            sortable: false,
            value: 'occupation',
          },
          {
            text: 'Duration',
            align: 'left',
            sortable: false,
            value: 'duration',
          },
          { 
            text: 'From',
            align: 'center',
            sortable: false,
            value: 'start_date',
          },
          { 
            text: 'To',
            align: 'center',
            sortable: false,
            value: 'end_date', 
          },
          { 
            text: 'Reason of Leaving',
            align: 'left',
            sortable: false,
            value: 'reason',
          },
          { 
            text: '',
            sortable: false,
            value: 'action', 
          },
        ],
        loading: false,
        panel: [0],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadWorkingExperiences()
          }
        },
      },
    },
  
    methods: {
      loadWorkingExperiences () {
        this.loading = true

        this.$api.hrisWorkingExperiences().list(this.employeeUid)
          .then(res => {
            this.workingExperiences = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
  max-height: 36px !important;
}

.border{
  border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  padding-left:0px
}
</style>
